import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ResendInvite from '../resend-invite'
import { PageContentUnderTitle } from 'components'
import { Table } from 'elements'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-list-view'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const StatusInvited = ({ row }) => (
  <Fragment>
    <span className={bemE('status-invited')}>Invited</span>
    <ResendInvite row={row} />
  </Fragment>
)

const columns = [
  {
    title: 'Client Reference',
    dataIndex: 'clientReference',
    sorter: (a, b) => a.clientReference.localeCompare(b.clientReference)
  },
  {
    title: 'Start Time',
    dataIndex: 'startTime',
    sorter: (a, b) => a.startTime.localeCompare(b.startTime)
  },
  {
    title: 'End Time',
    dataIndex: 'endTime',
    sorter: (a, b) => a.endTime.localeCompare(b.endTime)
  }
]

const ListView = ({ liveVisits }) => (
  <div className={COMPONENT_CSS_CLASSNAME}>
    {liveVisits.length > 0 && (
      <PageContentUnderTitle className={bemE('count')}>
        Showing {liveVisits.length} live visits
      </PageContentUnderTitle>
    )}
    <Table dataSource={liveVisits} columns={columns} pagination={false} rowKey="startTime" />
  </div>
)

export default ListView



// WEBPACK FOOTER //
// ./src/pages/realtime-view/realtime-list/components/list-view/index.js